module.exports = __webpack_public_path__ + "static/media/TileFPRT.ffc80d67.png";